var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAktif)?_c('feather',{staticClass:"font-success f-24",attrs:{"type":"check-square"}}):_c('feather',{staticClass:"font-danger f-24",attrs:{"type":"x"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }